import React, { Component } from 'react';
import { connect } from 'react-redux';

// Packages
import onClickOutside from 'react-onclickoutside';

// Actions
import {
  setActiveProfile,
} from '../../actions/activeProfile';

import {
  getProfileAccountDetails
} from '../../actions/accountDetails'

class ProfilePicker extends Component {

  state = {
    activeProfile: '',
    additionalProfiles: [],
    dropdownActive: false
  }

  componentDidMount() {
    const { reduxLogInComplete } = this.props.user;
    if (reduxLogInComplete) {
      this.initializeProfilePicker(this.props)
    }
  }

  componentWillReceiveProps(nextProps) {
    const { reduxLogInComplete } = nextProps.user;
    if (reduxLogInComplete) {
      this.initializeProfilePicker(nextProps)
    }

    if (nextProps.activeProfile.username !== this.props.activeProfile.username) {
      this.setState({isLoading: false})
    }
  }

  initializeProfilePicker(props) {
    const profiles = props.user.maintained_profiles
    const { username } = props.activeProfile;

    if (profiles && username) {
      let activeProfile = profiles.filter((profile) => {
        return profile.username === username;
      });

      let additionalProfiles = profiles.filter((profile) => {
        return profile.username !== username;
      });

      this.setState({
        activeProfile: activeProfile[0],
        additionalProfiles,
      })
    }
  }

  handleButtonClick = () => {
    this.toggleDropdown()
  }

  toggleDropdown() {
    this.setState({
      dropdownActive: !this.state.dropdownActive
    })
  }

  closeDropdown() {
    this.setState({
      dropdownActive: false
    })
  }

  handleClickOutside = (event) => {
    this.setState({
      dropdownActive: false
    })
  }

  handleNewProfileSelect = (event, username) => {
    event.preventDefault()

    this.setState({
      isLoading: true
    },
      () => {
        this.props.getProfileAccountDetails(this.props.user, username)
        .then(() => {
          this.props.setActiveProfile(username)
        })
      }
    )
  }

  render() {
    const {
      activeProfile,
      dropdownActive,
      additionalProfiles,
      isLoading
    } = this.state

    return additionalProfiles.length > 0 && activeProfile
    ? (
      <div className="profile-picker">
        <div
          className={`profile-picker-button${dropdownActive ? ' active' : ''}`}
          onClick={() => this.handleButtonClick()}
        >
          {
            isLoading
            ? (<div className="profile-picker-spinner"></div>)
            : (
                <span className="name">
                  {activeProfile.first_name} {activeProfile.last_name}
                </span>
              )
          }

          <ul className={`profile-picker-dropdown${dropdownActive ? ' active' : ''}`}>
            {
              additionalProfiles.map((profile, index) => {
                return (
                  <li className="profile-picker-dropdown-item" key={profile.last_name+index}>
                    <a
                      onClick={(event) => this.handleNewProfileSelect(event, profile.username)}
                    >
                      {profile.first_name} {profile.last_name}
                    </a>
                  </li>
                )
              })
            }
          </ul>
        </div>
      </div>
    )
    : null
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    activeProfile: state.activeProfile
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setActiveProfile: (username) => dispatch(setActiveProfile(username)),
    getProfileAccountDetails: (user, athleteUsername) =>
      dispatch(getProfileAccountDetails(user, athleteUsername)),
  }
}

ProfilePicker = onClickOutside(ProfilePicker);
ProfilePicker = connect(mapStateToProps, mapDispatchToProps)(ProfilePicker);

export default ProfilePicker



// WEBPACK FOOTER //
// ./src/components/Global/ProfilePicker.js